import authService from "src/helpers/authService";
import { Client } from "src/store/Client";
import { User } from "src/store/User";

export const RouteName = "coach-assignments";

export function authZ_hasSomeRoutePermission() {
  if (authService(User.userData?.roles ?? [], "volunteerAdmin", "RC", "webmaster")) {
    return true;
  }

  if (User.userData?.divisionsMemento.find(v => v.writeAccess)) {
    return true;
  }
  if (User.userData?.competitionsMemento.find(v => v.isVolunteerAdmin)) {
    return true;
  }

  if (
    (Client.value.instanceConfig.allcoachesassign || Client.value.instanceConfig.coachassign)
    && User.userData?.coachAssignmentsMemento.find(v => v.title === "Head Coach" || v.title === "Co-Coach")
  ) {
    return true;
  }

  return false;
}
